module.exports = __webpack_public_path__ + "img/10.1.8f667ad2.jpg";